import PropTypes from 'prop-types';
import { Skeleton } from 'antd';

export default function CurrentField({ state, label, children }) {
    if (state === 'loading') return <span className="monitoring-current-field" role="status" aria-label={label} aria-busy="true">
        <span aria-hidden="true"><Skeleton.Input active size="small" /></span>
    </span>;
    if (state === 'error') return <span className="monitoring-current-unavailable" title="Sensor data could not be loaded. Use Refresh to try again.">Unavailable</span>;
    return children;
}

CurrentField.propTypes = { state: PropTypes.string, label: PropTypes.string.isRequired, children: PropTypes.node };
